/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import { Module } from 'vuex'

export interface Task {
  username: string,
  token: string,
}

const taskModule: Module<any, any> = {

  state: {
    tasks: [],
    totalRows: 0
  },

  actions: {
    async GetTasks ({ commit }, { page, num, search }) {
      // const filterServerSide = false
      const todo = page + num + search

      const response = {
        data: [{
          id: 1,
          name: 'Draft 1,234 requires approval from Joanne Moniz',
          assignee: {
            id: 99,
            firstName: 'Courtney',
            lastName: 'Henry',
            profile: '/images/profile-img/img-02.jpg',
            username: 'c.henry@socialhp.com'
          },
          dateAdded: '2021-09-12'
        }, {
          id: 2,
          name: 'Your LinkedIn account requires a token refresh',
          assignee: {
            id: 100,
            firstName: 'Courtney',
            lastName: 'Henry',
            profile: '/images/profile-img/img-02.jpg',
            username: 'c.henry@socialhp.com'
          },
          dateAdded: '2021-09-22'
        }],

        totalRows: 2
      }
      // cSpell:enable

      commit('setTasks', response.data)
      commit('setTotalRows', response.totalRows)

      return response.data
    }

  },

  mutations: {
    setTasks (state: any, tasks) {
      state.tasks = tasks
    },
    setTotalRows (state: any, rows: number) {
      state.totalRows = rows
    }
  }

}

export default taskModule
/* jscpd:ignore-end */
